import React from 'react';
import { Calendar } from "@/components/ui/calendar";
import { Frown, Smile, CheckCircle, Star, Award } from 'lucide-react';
import { format } from 'date-fns';

export default function ProgressCalendar({ data, onDayClick, month, onMonthChange }) {

  const DayContent = ({ date, ...props }) => {
    const dayData = data[format(date, 'yyyy-MM-dd')];
    const isHappyDay = dayData && dayData.checkIn && dayData.checkIn.q3_breathing !== 'relapse';
    const isSadDay = dayData && dayData.checkIn && dayData.checkIn.q3_breathing === 'relapse';
    const activitiesCount = dayData ? Object.values(dayData.activities).filter(Boolean).length : 0;
    const goal = dayData?.goal;
    
    return (
      <div 
        className="relative w-full h-full flex flex-col items-center justify-center"
        {...props.divProps}
      >
        <span>{date.getDate()}</span>
        <div className="absolute top-0.5 right-0.5 flex">
          {isSadDay && <Frown className="w-3 h-3 text-red-500" />}
          {isHappyDay && !goal && <Smile className="w-3 h-3 text-green-500" />}
          {goal && <Award className="w-3 h-3 text-yellow-500" />}
        </div>
        <div className="absolute bottom-0.5 flex space-x-0.5">
          {Array.from({ length: Math.min(activitiesCount, 4) }).map((_, i) => (
            <div key={i} className="w-1 h-1 bg-blue-400 rounded-full" />
          ))}
        </div>
      </div>
    );
  };
  
  const modifiers = {
    hasData: Object.keys(data).map(dateStr => new Date(dateStr + 'T12:00:00')),
  };

  const modifiersClassNames = {
    hasData: 'has-data-modifier',
  };

  return (
    <>
     <style>{`
        .has-data-modifier {
          font-weight: bold;
          border: 1px solid #93c5fd; /* border-blue-300 */
          background-color: #eff6ff; /* bg-blue-50 */
          border-radius: 0.5rem;
        }
        .rdp-day_selected {
          background-color: #3b82f6 !important; /* bg-blue-600 */
          color: white;
        }
     `}</style>
      <Calendar
        mode="single"
        onDayClick={onDayClick}
        month={month}
        onMonthChange={onMonthChange}
        className="rounded-md border bg-white shadow-lg p-3"
        components={{ DayContent }}
        modifiers={modifiers}
        modifiersClassNames={modifiersClassNames}
        ISOWeek
      />
    </>
  );
}